import { Injectable } from "@angular/core";
import "@angular/common/locales/global/fr";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class TimeService {
  interval!: any;
  time!: string;
  bestTimeShow!: string;
  meanTimeShow!: string;

  constructor(private translate: TranslateService) {}

  /**
   * Affichage du temps en adaptant les unités
   * de manière cohérente
   * @param seconds la valeur des secondes
   * @param dailyMode définie la journée comme l'unité de mesure minimum
   */
  convertSecondsToBestUnit(seconds: number, dailyMode = false): string {
    let years = Math.floor(seconds / 31_104_000);
    let months = Math.floor(seconds / 2_592_000) % 12;
    let days = (Math.floor(seconds / 86_400) % 30) + (dailyMode ? 1 : 0); // Add +1 if dailyMode to avoid a '0J' countdown
    let hours = Math.floor(seconds / 3600) % 24;
    let minutes = Math.floor(seconds / 60) % 60;
    let remainingSeconds = Math.floor(seconds) % 60;
    if (years > 0) {
      return `> 1 ${this.translate.instant("time.year")}`;
    }
    if (months > 0) {
      return `${months}M ${days}${this.translate.instant("time.dayAbbr")}`;
    }
    if (days > 0) {
      return dailyMode
        ? `${days} ${this.translate.instant("time.day")}${days === 1 ? "" : "s"}`
        : `${days}${this.translate.instant("time.dayAbbr")} ${hours}H`;
    }
    return `${this.zeroPad(hours)}:${this.zeroPad(minutes)}:${this.zeroPad(remainingSeconds)}`;
  }

  /**
   * Début du timer, définition de l'intervalle
   * @param startDate
   */
  startTimer(startDate: Date) {
    this.setTimer(startDate, this.nowUTC());
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.setTimer(startDate, this.nowUTC());
      }, 1000);
    }
  }

  /**
   * Arret du timer
   */
  stopTimer() {
    clearInterval(this.interval);
    this.interval = undefined;
  }

  /**
   * Définition du temps actuel par la différence de 2 temps
   * @param startDate Date de début
   * @param endDate Date de fin
   */
  setTimer(startDate: Date, endDate: Date) {
    if (endDate.getTime() < startDate.getTime()) {
      this.time = "00:00:00";
    } else {
      this.time = this.convertSecondsToBestUnit(
        (new Date(endDate).getTime() - new Date(startDate).getTime()) / 1000,
      );
    }
  }

  /**
   * Retourne la date actuelle au format UTC
   */
  nowUTC(): Date {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    return new Date(now.getTime() + offset * 60_000);
  }

  /**
   * Ajout de zeros pour avoir un affichage sur 2 digits
   * @param time
   * @private
   */
  private zeroPad(time: number): string {
    return time.toString().padStart(2, "0");
  }
}
